export default __webpack_public_path__ + "static/media/aviao.4690837c.png";